import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import { SnackbarProvider } from 'notistack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/fr';

import Header from './app/header/header';
import RootPages from './pages';
import MainMenu from './app/main-menu';
import Footer from './app/footer';
import './locale/i18n'

import { GoogleTagManagerProvider } from './app/gmt.ctx';

function App() {

  React.useEffect(() => {
    const anchor = sessionStorage.getItem('anchor');
    if(anchor) {
      sessionStorage.removeItem('anchor');
      window.location.hash = anchor;
    }
  }, []);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="fr"
    >
      <GoogleTagManagerProvider>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <Box sx={{ display: 'flex' }}>
            <CssBaseline/>
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                minHeight: '100vh',
                overflow: 'auto',
              }}
            >
              <Header/>
              <Container maxWidth="xl" sx={{ mb: 4 }}>
                <Grid container>
                  <Grid item xs={12} sx={{ marginBottom: '16px' }}>
                    <MainMenu/>
                  </Grid>
                  <Grid item xs={12}>
                    <RootPages/>
                  </Grid>
                </Grid>
              </Container>
              <Footer/>
            </Box>
          </Box>
        </SnackbarProvider>
      </GoogleTagManagerProvider>
    </LocalizationProvider>
  );
}

export default App;
